/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kostenstelleprozentsaetze1Inputs */



/**

* @param {_Field_Kostenstelleprozentsaetze1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kostenstelleprozentsaetze1 = /** @type {((inputs?: _Field_Kostenstelleprozentsaetze1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kostenstelleprozentsaetze1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kostenstellen")
});
export { _field_kostenstelleprozentsaetze1 as "_field_kostenstelleProzentsaetze" }